module.exports = __webpack_public_path__ + "media/images/service/tech_bg-0a8d8588840bb2f7d51a16d14b30fb25.png";